import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import CsvViewer from './components/CsvViewer';
import Header from './components/Header';
import Footer from './components/Footer';
import AboutPage from './components/AboutPage';
import ShoppingCart from './components/ShoppingCart';
import Brands from './components/Brands';
import BrandDetail from './components/BrandDetail';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './context/LanguageContext';

// Main App component
function App() {
  // Google Analytics is loaded via HTML script tag
  useEffect(() => {
    console.log('analytics loaded');
  }, []);

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <LanguageProvider>
        <CartProvider>
          <div className="app">
            <Header />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<CsvViewer />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/products" element={<CsvViewer />} />
                <Route path="/cart" element={<ShoppingCart />} />
                <Route path="/brands" element={<Brands />} />
                <Route path="/brands/:id" element={<BrandDetail />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </CartProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
